import { TranslateHelper } from "../../helpers/injector.helper";
import { ValueAndType } from "../basic/formulaEditor.model";
import { OperationType } from "../enums/operationtype.enum";
import { ValueType } from "../enums/valuetype.enum";
import { FormulaNodeCalculator } from "./formula.node.calculator";
import { AFormula, FormulaGroups } from "./iformula";

export class LTrim extends AFormula {
    static StaticID: string = '4af96c39-b9ed-4088-95af-8bf3a94a1394';

    ID(): string {
        return LTrim.StaticID;
    }

    Name(): string {
        return 'LTrim';
    }

    Description(): string {
        return TranslateHelper.TranslatorInstance.instant('@@Kuerzen einer Zeichenkette an der linken Seite');
    }

    Group(): string {
        return FormulaGroups.Functions;
    }

    OrderID(): number {
        return 14;
    }

    OperationType(): OperationType {
        return OperationType.Function;
    }

    OperationValue(): string {
        return this.Name() + '('
            + TranslateHelper.TranslatorInstance.instant('@@Text') + '; '
            + TranslateHelper.TranslatorInstance.instant('@@Zeichen') + ')';
    }

    MaxVariableCount(): number {
        return 2;
    }

    Calc(fnc: FormulaNodeCalculator, maxType: ValueType, args?: ValueAndType[]): ValueAndType {
        var retVal = new ValueAndType();
        retVal.Type = ValueType.String;
        retVal.Value = '';
        if (args && args.length > 0) {
            var text = '';
            var trimChar = ' ';
            if (typeof args[0].Value !== 'undefined' && args[0].Value != null) {
                text = String(args[0].Value);
            }
            if (args.length > 1 && typeof args[1].Value !== 'undefined' && args[1].Value != null) {
                var tc = String(args[1].Value);
                if (tc && tc.length > 0) {
                    trimChar = tc[0];
                }
            }
            var index = 0;
            while (text.length > index && text[index] == trimChar) {
                index++;
            }
            retVal.Value = text.substr(index);
        }
        return retVal;
    }
}